export default "__VITE_ASSET__B1VvqOLN__"